/**
 * Per part costs from a CSV (B2, docs/plans/2026-10-18_actionable-platform.md): what a rejected casting of each part
 * costs, matched to the Catalog's products, with a dry run that reports the unknown parts. The Go mirror is
 * platform-core/internal/twin/products_costs.go; change the two together.
 *
 *   POST /v1/twin/products/costs/import   { csv, dry_run }   org admins
 *     400 invalid_csv | too_many_rows | currency_required
 */
import { api } from "@/lib/api-client";

export interface PartCostRow {
  /** The header is line 1. */
  line: number;
  part: string;
  product_id: string;
  cost: number;
  /** The file's cost, or its weight at the plant's cost per kilogram. */
  basis: "given" | "weight";
  weight_kg?: number;
  /** The cost the product held; null for none. */
  was: number | null;
  unchanged: boolean;
}

export interface PartCostError {
  line: number;
  part?: string;
  error: string;
}

export interface PartCostImport {
  dry_run: boolean;
  currency: string;
  rows: number;
  priced: PartCostRow[];
  unknown_parts: string[];
  errors: PartCostError[];
  written: number;
  unchanged: number;
}

/** Checks (dry run) or imports a file of per part costs. */
export function importPartCosts(csv: string, dryRun: boolean): Promise<PartCostImport> {
  return api.post<PartCostImport>("/v1/twin/products/costs/import", { csv, dry_run: dryRun });
}
